import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import About from "./pages/About";
import GovProfile from "./pages/GovProfile";
import Products from "./pages/Products";
import RenewableEnergy from "./pages/RenewableEnergy";
import Institutional from "./pages/Institutional";
import ITCCTV from "./pages/ITCCTV";
import Card from "./pages/Card";
import Downloads from "./pages/Downloads";
import SubmitRequirement from "./pages/SubmitRequirement";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/government-contractor" element={<GovProfile />} />
            <Route path="/products" element={<Products />} />
            <Route path="/renewable-energy" element={<RenewableEnergy />} />
            <Route path="/institutional" element={<Institutional />} />
            <Route path="/it-cctv-smart-classroom" element={<ITCCTV />} />
            <Route path="/card" element={<Card />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="/submit" element={<SubmitRequirement />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
